import PropTypes from "prop-types"
import { Navigate, useLocation } from "react-router-dom"
import localStorageService from "../../services/localStorage.service"

function hasCrmStaffAccess(profile) {
  return Boolean(
    profile?.isStaff || profile?.isCalendarAdmin || profile?.isPlatformAdmin
  )
}

const CrmProtectedRoute = ({ children }) => {
  const location = useLocation()

  if (!localStorageService.isUserSessionValid()) {
    return <Navigate to="/crm/login" replace state={{ from: location }} />
  }

  const profile = localStorageService.getUserProfile()
  if (profile && !hasCrmStaffAccess(profile)) {
    return (
      <Navigate
        to="/crm/login"
        replace
        state={{ from: location, crmAccessDenied: true }}
      />
    )
  }

  return children
}

CrmProtectedRoute.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
}

export default CrmProtectedRoute
